<div [edsSpacing]="(isHandheld$ | async) ? 'xxl' : 'none'">
  <div edsSpacing="lg">
    <eds-radio-group
      *ngIf="profileData?.isLoggedIn"
      (radioChange)="updateRecepient($event)"
    >
      <eds-radio
        [id]="1"
        name="story-radiogroup"
        value="1"
        [checked]="(clientType$ | async) !== 'myClient'"
        labelName="{{ 'literature.mail-form-radio-label-me' | translate }}"
      >
      </eds-radio>
      <div edsPadding [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'sm'">
        <p
          class="small text-grey1"
          edsPadding
          [edsPaddingLeft]="(isHandheld$ | async) ? 'lg' : 'md'"
          edsPaddingTop="sm"
        >
          {{ "literature.mail-form-radio-me-description" | translate }}
        </p>
      </div>
      <ng-container *ngIf="!isShareHolder">
        <eds-radio
          [id]="2"
          name="story-radiogroup"
          value="2"
          [checked]="(clientType$ | async) === 'myClient'"
          labelName="{{
            'literature.mail-form-radio-label-myClient' | translate
          }}"
        >
        </eds-radio>
        <div edsPadding [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'sm'">
          <p
            class="small text-grey1"
            edsPadding
            [edsPaddingLeft]="(isHandheld$ | async) ? 'lg' : 'md'"
            edsPaddingTop="sm"
          >
            {{ "literature.mail-form-radio-myClient-description" | translate }}
          </p>
        </div>
      </ng-container>
    </eds-radio-group>
    <div *ngIf="showAlert && isClientUseNo" edsPadding edsPaddingTop="lg">
      <eds-notifications
        [hasBorders]="true"
        [hasBorderRadius]="true"
        [hasShadows]="true"
        [title]="alertTitle"
        [body]="clientUseMsg"
        [notificationType]="'error'"
        [canClose]="false"
      >
      </eds-notifications>
    </div>
    <div *ngIf="showBlueSkyAlert" edsPadding edsPaddingTop="lg">
      <eds-notifications
        [hasBorders]="true"
        [hasBorderRadius]="true"
        [hasShadows]="true"
        [title]="alertTitle"
        [body]="blueSkyStateMsg.toString()"
        [notificationType]="'error'"
        [canClose]="false"
      >
      </eds-notifications>
    </div>
  </div>
  <form [formGroup]="mailDetails">
    <div edsSpacing="md">
      <ng-container
        [ngTemplateOutlet]="inputFormField"
        [ngTemplateOutletContext]="{
          textInputProperty: {
            placeHolder: 'literature.mail-form-field-placeholder-first-name',
            label: 'literature.mail-form-field-label-first-name',
            required: true,
            fieldName: 'firstName'
          }
        }"
      >
      </ng-container>
    </div>
    <div edsSpacing="md">
      <ng-container
        [ngTemplateOutlet]="inputFormField"
        [ngTemplateOutletContext]="{
          textInputProperty: {
            placeHolder: 'literature.mail-form-field-placeholder-last-name',
            label: 'literature.mail-form-field-label-last-name',
            required: true,
            fieldName: 'lastName'
          }
        }"
      >
      </ng-container>
    </div>
    <div edsSpacing="md">
      <ng-container
        [ngTemplateOutlet]="inputFormField"
        [ngTemplateOutletContext]="{
          textInputProperty: {
            placeHolder: 'literature.mail-form-field-placeholder-addressLine1',
            label: 'literature.mail-form-field-label-addressLine1',
            required: true,
            fieldName: 'addressLine1'
          }
        }"
      >
      </ng-container>
    </div>
    <div edsSpacing="md">
      <ng-container
        [ngTemplateOutlet]="inputFormField"
        [ngTemplateOutletContext]="{
          textInputProperty: {
            placeHolder: 'literature.mail-form-field-placeholder-addressLine2',
            label: 'literature.mail-form-field-label-addressLine2',
            type: 'type',
            required: false,
            fieldName: 'addressLine2'
          }
        }"
      >
      </ng-container>
    </div>
    <div edsSubGrid="layout-3">
      <div edsSpacing="xl">
        <div edsSpacing="lg">
          <ng-container
            [ngTemplateOutlet]="inputFormField"
            [ngTemplateOutletContext]="{
              textInputProperty: {
                placeHolder: 'literature.mail-form-field-placeholder-city',
                label: 'literature.mail-form-field-label-city',
                required: true,
                fieldName: 'city'
              }
            }"
          >
          </ng-container>
        </div>
        <div edsSpacing="lg">
          <eds-dropdown
            ariaLabel="Dropdown"
            [dropdownId]="'stateCode'"
            name="drop-down"
            [items]="dropdownItems"
            [preselectedValue]="dropdownItems[0]"
            (dropdownChange)="checkBlueSkyState($event)"
            required="true"
            [invalid]="
              mailDetails.get('stateCode').invalid &&
              mailDetails.get('stateCode').touched &&
              showError
            "
            [invalidText]="validatorFunction(true, 'stateCode')"
            label="{{ 'literature.mail-form-field-label-state' | translate }}"
            titleText="Select Item"
            formControlName="stateCode"
            [hideRequiredMark]="true"
          ></eds-dropdown>
        </div>
        <ng-container
          [ngTemplateOutlet]="inputFormField"
          [ngTemplateOutletContext]="{
            textInputProperty: {
              placeHolder: 'literature.mail-form-field-placeholder-zip',
              label: 'literature.mail-form-field-label-zip',
              required: true,
              fieldName: 'zip'
            }
          }"
        >
        </ng-container>
      </div>
    </div>
    <div edsSpacing="lg">
      <eds-title
        title="{{ 'literature.mail-title-contact-detail' | translate }}"
        size="h6"
        theme="basic"
        [level]="1"
        [isLight]="false"
        edsSpacing="md"
      ></eds-title>
      <div edsSpacing="md">
        <ng-container
          [ngTemplateOutlet]="inputFormField"
          [ngTemplateOutletContext]="{
            textInputProperty: {
              placeHolder:
                'literature.mail-form-field-placeholder-phone-number',
              label: 'literature.mail-form-field-label-phone-number',
              required: true,
              fieldName: 'workPhone',
              inputTextChange: updatePhoneFormat,
              mailDetails: mailDetails
            }
          }"
        >
        </ng-container>
      </div>
      <div edsSpacing="md">
        <ng-container
          [ngTemplateOutlet]="inputFormField"
          [ngTemplateOutletContext]="{
            textInputProperty: {
              placeHolder: 'literature.mail-form-field-placeholder-email',
              label: 'literature.mail-form-field-label-email',
              required: true,
              fieldName: 'emailAddress'
            }
          }"
        >
        </ng-container>
      </div>
    </div>
  </form>
  <div edsFlexbox>
    <div edsPadding edsPaddingRight="sm">
      <button edsButton="secondary" size="normal" (click)="goToYourCart()">
        <span>{{ "literature.mail-back-button" | translate }}</span>
      </button>
    </div>
    <button
      edsButton="primary"
      size="normal"
      (click)="setFormValues()"
      [disabled]="showBlueSkyAlert || (showAlert && isClientUseNo)"
    >
      <span>{{ "literature.mail-continue-order-button" | translate }}</span>
    </button>
  </div>
</div>
<ng-template let-textInputProperty="textInputProperty" #inputFormField>
  <eds-text-input
    placeholder="
      {{ textInputProperty.placeHolder | translate }}"
    value=""
    label="{{ textInputProperty.label | translate }}"
    type="type"
    [required]="textInputProperty.required"
    aria-label="inputText"
    [hasHelperText]="true"
    [invalid]="
      textInputProperty.required &&
      mailDetails.get(textInputProperty.fieldName).invalid &&
      mailDetails.get(textInputProperty.fieldName).touched &&
      showError
    "
    [invalidText]="
      mailDetails.get(textInputProperty.fieldName).invalid &&
      mailDetails.get(textInputProperty.fieldName).touched
        ? validatorFunction(
            mailDetails.get(textInputProperty.fieldName).errors?.required,
            textInputProperty.fieldName
          )
        : ''
    "
    [inputControl]="mailDetails.controls[textInputProperty.fieldName]"
    [hideRequiredMark]="true"
    (inputTextChange)="
      textInputProperty.inputTextChange &&
        textInputProperty.inputTextChange($event)
    "
  ></eds-text-input>
</ng-template>
